import { Loader2, Plus } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useCreateDeepResearchReport } from "@/hooks/api/use-deep-research";
import { usePageTitle } from "@/hooks/use-page-title";
import { DeepResearchDataTable } from "./deep-research-data-table";

export default function DeepResearchListView() {
  usePageTitle("Deep Research Datasets");
  const navigate = useNavigate();
  const [isCreating, setIsCreating] = useState(false);
  const createReportMutation = useCreateDeepResearchReport();

  const handleCreateNew = async () => {
    try {
      setIsCreating(true);
      const newReport = await createReportMutation.mutateAsync({
        name: `Dataset ${new Date().toLocaleString()}`,
        entity_type: "opportunity",
        dataset_type: "static",
      });
      navigate(`/deep-research/${newReport.id}`);
    } catch {
      toast.error("Failed to create dataset");
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="flex flex-col h-full space-y-4">
      <div className="shrink-0">
        <div className="flex flex-col space-y-4 pt-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:space-x-4">
          <h1>Deep Research Datasets</h1>
          <Button onClick={handleCreateNew} size="sm" disabled={isCreating}>
            {isCreating ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Plus className="mr-2 h-4 w-4" />
            )}
            Create New Dataset
          </Button>
        </div>
      </div>

      <div className="flex-1 min-h-0">
        <DeepResearchDataTable />
      </div>
    </div>
  );
}
